import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

import * as GeneralActions from 'af-actions/general';

interface OwnProps {
	showModal?: boolean;
	message: string;
	size?: 'sm' | 'md' | 'lg';
	onRefresh?: () => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const RefreshModal: React.FC<Props> = (props) => {
	const { hideRefreshModal, onRefresh, size = 'sm', showModal, message } = props;

	const refreshPage = React.useCallback(async () => {
		hideRefreshModal?.();
		if (onRefresh) {
			onRefresh();
		}
		window.location.reload();
	}, [hideRefreshModal, onRefresh]);

	return (
		<CustomModal
			className={`refresh-modal modal-${size}`}
			closeModal={refreshPage}
			showModal={showModal}
		>
			<CustomModal.Header
				title="Info"
			/>
			<CustomModal.Body>
				{message}
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Refresh"
					onClick={refreshPage}
					style="primary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapDispatchToProps() {
	return {
		hideRefreshModal: GeneralActions.hideRefreshModal,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(RefreshModal);
